module.exports = __webpack_public_path__ + "img/load-seta.49886bcf.gif";